import { createFileRoute, Link } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";

import { Card, PageHeading, Stack } from "~/components";
import { CASE_WORKFLOW_NAME } from "~/lib/cases";
import { queryClient } from "~/lib/queryClient";
import { workflowsListQueryOptions } from "~/lib/workflows";

import * as css from "~/routes/_app.alpha.settings.css";

// Intake settings — the configuration that ISN'T already something the
// workflow says, and isn't code either. The funnel used to be configured here
// (stage rows, a speed-to-lead SLA); both were duplicates of the graph
// (TMF-319). How a matter ENDS was configured here too, until the close-out
// vocabulary became a Go enum (TMF-284). Triage went the same way (TMF-277):
// the questions, their points and the tier cut-offs are a constant the API
// owns, so there are no dials left to turn.
//
// Shape: a Stack of Cards, one Card per setting group. Add a group by
// adding a Card; the page itself has no layout of its own to touch.
export const Route = createFileRoute("/_app/alpha/settings")({
  loader: async () => {
    await queryClient.ensureQueryData(workflowsListQueryOptions);
  },
  component: SettingsPage,
});

function SettingsPage() {
  const { data: workflowCol } = useSuspenseQuery(workflowsListQueryOptions);
  const caseWorkflow = (workflowCol._embedded ?? []).find(
    (w) => w.name === CASE_WORKFLOW_NAME,
  );

  return (
    <Stack gap="lg" className={css.page}>
      <PageHeading
        title="Settings"
        subtitle="Alpha's configuration. Whatever the Case workflow already owns is edited there, not here."
      />

      <Card>
        <Stack gap="sm">
          <h3>The funnel is a workflow</h3>
          <p>
            Stages, the order they run in, and how long the firm has to make first contact
            all live in the <strong>{CASE_WORKFLOW_NAME}</strong> workflow. Edit it there
            and the board follows — no deploy, nothing to keep in sync here.
          </p>
          {caseWorkflow ? (
            <Link to="/workflows/$id/edit" params={{ id: caseWorkflow.id }}>
              Edit the {CASE_WORKFLOW_NAME} workflow
            </Link>
          ) : (
            <p>
              No <strong>{CASE_WORKFLOW_NAME}</strong> workflow exists yet. Run{" "}
              <code>make seed</code> to load it.
            </p>
          )}
        </Stack>
      </Card>
    </Stack>
  );
}
